import React from 'react';
import { Outlet } from 'react-router-dom';

interface LayoutProps {
    children?: React.ReactNode; // Make `children` optional
}

const Layout: React.FC<LayoutProps> = ({ children }) => {
    return (
        <div className="layout">
            {children || <Outlet />} {/* Render children or nested routes */}
        </div>
    );
};

export default Layout;
